import type { CSSProperties } from "react";
import { makeStyles } from "@material-ui/core";
import {
  h4Medium,
  h5Medium,
  h6Medium,
  h6Regular,
  h7Regular,
} from "../../../shared/typography";

// Shared with verify-number-container's loading state and with the
// "Change number" (AddPhone) screen it swaps to inside the same modal, so
// the card is the same size in all three states and never visibly
// resizes. 440 matches AddPhone's PhoneInput at its established width of
// 360 (see account-personal-info.styles.ts) plus this card's 40px padding
// on each side.
export const VERIFY_NUMBER_WIDTH = 440;
export const VERIFY_NUMBER_HEIGHT = 640;

// Caps at the fixed desktop size above, but shrinks to fit narrow/short
// viewports (phones) instead of overflowing or getting clipped.
export const verifyNumberResponsiveSize = {
  width: `min(${VERIFY_NUMBER_WIDTH}px, calc(100vw - 32px))`,
  height: `min(${VERIFY_NUMBER_HEIGHT}px, calc(100vh - 64px))`,
};

// shared/typography.ts types these as JSS's CreateCSSProperties (for makeStyles),
// which isn't assignable to React's plain inline `style` prop — cast once for reuse there.
export const inline = {
  h5Medium: h5Medium as CSSProperties,
  h6Medium: h6Medium as CSSProperties,
  h6Regular: h6Regular as CSSProperties,
  h7Regular: h7Regular as CSSProperties,
};

export const inputDigitStyle = {
  border: "none",
  borderBottom: "1px solid lightgrey",
  background: "none",
  outline: "none",
  // Flex items don't shrink below their content's intrinsic min-width by
  // default, so a plain `maxWidth` here doesn't actually cap a text
  // input's rendered size — they'd overflow the row and end up pressed
  // right up against each other, reading as one continuous underline
  // instead of 6 separate boxes. `width` + `minWidth: 0` fixes that.
  width: 30,
  minWidth: 0,
  flexShrink: 0,
  padding: 10,
  ...inline.h5Medium,
  textAlign: "center" as const,
};

export const useStyles = makeStyles({
  container: {
    ...verifyNumberResponsiveSize,
    background: "#FFFFFF",
    boxShadow: "0px 16px 32px rgba(29, 38, 102, 0.08)",
    borderRadius: 32,
    padding: 40,
    boxSizing: "border-box",
    overflowY: "auto",

    "@media (max-width: 480px)": {
      padding: 24,
      borderRadius: 20,
    },
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    ...h4Medium,
    marginBottom: 16,
  },
});
